import {observer} from 'mobx-react-lite';

/**
 * `observer` typed as an identity function so that generic components keep
 * their type parameters — mobx's own typing collapses them to their defaults.
 */
export const typedObserver: <T>(component: T) => T = observer;
